import React, { useEffect, useState } from "react";
import { Result, Button, Spin } from "antd";
import { useNavigate } from "react-router-dom";
import { api } from "../../api/api";

export default function Maintenance() {
  const navigate = useNavigate();
  const [isChecking, setIsChecking] = useState(false);

  useEffect(() => {
    // Проверяем статус режима обслуживания каждые 10 секунд
    const checkMaintenanceStatus = async () => {
      try {
        const response = await api.get("/settings/maintenance-mode");
        const maintenanceMode = response.data.maintenanceMode || false;
        
        // Если режим обслуживания выключен, редиректим на главную
        if (!maintenanceMode) {
          const token = localStorage.getItem("token");
          if (token) {
            navigate("/");
          } else {
            navigate("/login");
          }
        }
      } catch (error) {
        // Игнорируем ошибки при проверке
        console.error("Ошибка при проверке статуса обслуживания:", error);
      }
    };

    // Проверяем сразу
    checkMaintenanceStatus();

    // Устанавливаем интервал для периодической проверки
    const interval = setInterval(checkMaintenanceStatus, 10000);

    return () => clearInterval(interval);
  }, [navigate]);

  const handleRetry = () => {
    setIsChecking(true);
    window.location.reload();
  };

  const handleGoToLogin = () => {
    localStorage.clear();
    navigate("/login");
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f0f2f5",
      }}
    >
      {isChecking ? (
        <Spin size="large" tip="Проверка статуса..." />
      ) : (
        <Result
          status="error"
          title="Сервис временно недоступен"
          subTitle="Ведутся технические работы. Пожалуйста, попробуйте позже. Страница автоматически обновится, когда сервис будет доступен."
          extra={[
            <Button type="primary" key="retry" onClick={handleRetry}>
              Обновить страницу
            </Button>,
            <Button key="login" onClick={handleGoToLogin}>
              Вернуться на страницу входа
            </Button>,
          ]}
        />
      )}
    </div>
  );
}
